const FreeWithYourPurchaseIcon = () => {
    return (
        <svg
            width="80"
            height="57"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            viewBox="0 0 70 50" xmlSpace="preserve">

            <circle fill="#3452FF" cx="35" cy="25" r="24.6"/>
            <path fill="#fff"
                  d="M25.1 22.9l6.8 7v9.5H26.2v-4.1l-5.7-7.5c-.2-.3-.4-.6-.4-1V15.2c0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6v6.7c-.4.1-.8.3-1.1.5-.9.9-.9 2.3 0 3.1l3.1 3.2.4-.4-3.1-3.2c-.6-.6-.6-1.7 0-2.3.2-.2.4-.3.7-.4.3-.1.6-.1.8 0 .5.1.8.3 1 .5zm19.8 0l-6.8 7v9.5H43.8v-4.1l5.7-7.5c.2-.3.4-.6.4-1V15.2c0-.9-.7-1.6-1.6-1.6-.9 0-1.6.7-1.6 1.6v6.7c.4.1.8.3 1.1.5.9.9.9 2.3 0 3.1l-3.1 3.2-.4-.4 3.1-3.2c.6-.6.6-1.7 0-2.3-.2-.2-.4-.3-.7-.4-.3-.1-.5-.1-.8 0-.5.1-.8.3-1 .5zM29.8 17.3s-.4-2.3-.5-2.9c-.1-.6-.2-1.1-.3-1.8-.2-.7-.2-.9-.4-1.4-.1-.2-.2-.6-.5-.6s-.4.3-.5.6c-.2.5-.2.8-.4 1.4-.2.7-.2 1.2-.4 1.9-.1.7-.3 1.7-.5 2.9l3.5-.1zM36.7 17.3s-.4-2.3-.5-2.9c-.1-.6-.2-1.1-.3-1.8-.2-.7-.2-.9-.4-1.4-.1-.2-.2-.6-.5-.6s-.4.3-.5.6c-.2.5-.2.8-.4 1.4-.2.7-.2 1.2-.4 1.9-.1.7-.3 1.7-.5 2.9l3.5-.1z"/>
            <path fill="#fff"
                  d="M29.8 17.3s.4 2.3.5 2.9c.1.6.2 1.1.3 1.8.2.7.2.9.4 1.4.1.2.2.6.5.6s.4-.3.5-.6c.2-.5.2-.8.4-1.4.2-.7.2-1.2.4-1.9.1-.7.3-1.7.5-2.9l-3.5.1zM36.7 17.3s.4 2.3.5 2.9c.1.6.2 1.1.3 1.8.2.7.2.9.4 1.4.1.2.2.6.5.6s.4-.3.5-.6c.2-.5.2-.8.4-1.4.2-.7.2-1.2.4-1.9.1-.7.3-1.7.5-2.9l-3.5.1z"/>
            <path fill="#fff"
                  d="M43.6 17.3s-.4-2.3-.5-2.9c-.1-.6-.2-1.1-.3-1.8-.2-.7-.2-.9-.4-1.4-.1-.2-.2-.6-.5-.6s-.4.3-.5.6c-.2.5-.2.8-.4 1.4-.2.7-.2 1.2-.4 1.9-.1.7-.3 1.7-.5 2.9l3.5-.1z"/></svg>
    )
};

export default FreeWithYourPurchaseIcon;